// import React, { useState } from "react";
// import {
// 	Backdrop,
// 	Button,
// 	CircularProgress,
// 	Dialog,
// 	DialogActions,
// 	DialogContent,
// 	DialogTitle,
// 	TextField
// } from "@mui/material";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import { t } from "i18next";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import axios from "axios";
// import Loading from "../../../common/loading";
// import { getLocalStorageMenuItem, setLocalStorageMenuItem, setMobileBackColor, setMobileCardColor, setMobileTextColor } from "../../../utility";
// import SaveCustomerNameDialog from "../../SaveCustomerNameDialog";
// import { useLocation, useNavigate } from "react-router-dom";
// import Toast from "../../../common/toast";

// const LoginComponent = ({
// 	open,
// 	handleCloseDialog,
// 	tableQr,
// 	tableName,
// 	onVerificationSuccess,
// 	is_from

// }) => {

// 	const [verificationCode, setVerificationCode] = useState("");
// 	const [loading, setLoading] = useState(false);
// 	const [phone, setPhone] = useState("");
// 	const [openVerifiyDialog, setOpenVerifiyDialog] = useState(false);
// 	const [customerName, setCustomerName] = useState("");
// 	const [openSaveNameDialog, setOpenSaveNameDialog] = useState(false);
// 	const [token, setToken] = useState("");

// 	const [toastSettings, setToastSettings] = useState({
// 		open: false,
// 		message: "",
// 		success: false,
// 	});

// 	const handleOpenToast = (message, state) => {
// 		setToastSettings({
// 			open: true,
// 			success: state,
// 			message: message
// 		});
// 	};

// 	const handleCloseToast = (event, reason) => {
// 		if (reason === "clickaway") {
// 			return;
// 		}

// 		setToastSettings({ open: false, message: "", success: false });
// 	};

// 	function useQueryParams() {
// 		const { search } = useLocation();
// 		return new URLSearchParams(search);
// 	}

// 	const navigate = useNavigate();
// 	const query = useQueryParams();

// 	const tParam = query.get("t");
// 	const lang = query.get("lang");

// 	const validationSchema = Yup.object().shape({
// 		phoneNumber: Yup.string()
// 			.required(t("Phone number is required"))
// 			.test(
// 				"isValidPhoneNumber",
// 				t("Enter a valid phone number"),
// 				(value) => isValidPhoneNumber(value || "")
// 			),
// 	});


// 	const handleOpenSaveNameDialog = (token) => {
// 		setToken(token);
// 		setOpenVerifiyDialog(false);
// 		setOpenSaveNameDialog(true);
// 	}

// 	const saveCustomerName = async () => {
// 		if (!customerName) {
// 			handleOpenToast(
// 				<div className="alignByLang">
// 					{t("Please enter your name.")}
// 				</div>
// 				, false);
// 			return;
// 		}
// 		setLoading(true);
// 		try {
// 			const response = await axios.post(`${process.env.REACT_APP_API}/customer/save-name`, {
// 				name: customerName,
// 			}, {
// 				headers: {
// 					Authorization: `Bearer ${token}`,
// 				}
// 			});
// 			if (response?.data?.success) {
// 				handleOpenToast(
// 					<div className="alignByLang">
// 						{t("Name updated successfully.")}
// 					</div>
// 					, true);
// 				onVerificationSuccess(token);
// 				setOpenSaveNameDialog(false);
// 			} else {
// 				handleOpenToast(
// 					<div className="alignByLang">
// 						{t("Error while saving the name.")}
// 					</div>
// 					, false);

// 			}
// 		} catch (error) {

// 			handleOpenToast(
// 				<div className="alignByLang">
// 					{t("Error while saving the name: ") + error.message}
// 				</div>
// 				, false);
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	const handleSendCode = async (values) => {
// 		setLoading(true);
// 		try {
// 			const response = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
// 				phone: values.phoneNumber,
// 				menu_code: tableQr,
// 			});

// 			if (response?.data?.success) {
// 				setPhone(values.phoneNumber);
// 				handleCloseDialog();
// 				setOpenVerifiyDialog(true)
// 			} else {

// 				handleOpenToast(
// 					<div className="alignByLang">
// 						{t("Error while sending the verification code.")}
// 					</div>
// 					, false);
// 			}
// 		} catch (error) {
// 			handleOpenToast(
// 				<div className="alignByLang">
// 					{t("Error while sending the verification code: ") + error.message}
// 				</div>
// 				, false);
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	const handleVerifyCode = async () => {
// 		setLoading(true);
// 		try {
// 			const response = await axios.post(`${process.env.REACT_APP_API}/customer/check-otp`, {
// 				phone,
// 				otp: verificationCode,
// 			});


// 			if (response?.data?.success) {
// 				if (response?.data?.data?.name) {
// 					setLocalStorageMenuItem("customer_name", response?.data?.data?.name || "");
// 					setLocalStorageMenuItem("customer_balance", response?.data?.data?.balance || 0);
// 					setLocalStorageMenuItem("mobileLoginToken", response?.data?.data?.token || "");
// 					onVerificationSuccess(response?.data?.data?.token);
// 					setOpenVerifiyDialog(false);

// 					if (is_from === 1) {
// 						navigate(`/${tableName}/${tableQr}/sections?section=0&t=${tParam}&lang=${lang}`);

// 					} else if (is_from === 2) {

// 						window.location.reload();
// 					}
// 				} else {
// 					handleOpenSaveNameDialog(response?.data?.data?.token);

// 				}

// 			} else {

// 				handleOpenToast(
// 					<div className="alignByLang">
// 						{t("Error while verifying the code.")}
// 					</div>
// 					, false);
// 			}
// 		} catch (error) {
// 			handleOpenToast(
// 				<div className="alignByLang">
// 					{t("Error while verifying the code: ") + error.message}
// 				</div>
// 				, false);
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	if (loading) {
// 		return <Loading />;
// 	}

// 	return (
// 		<div>
// 			<ToastContainer />
// 			<Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
// 				<CircularProgress color="inherit" />
// 			</Backdrop>
// 			<Dialog
// 				open={open} onClose={handleCloseDialog} fullWidth maxWidth="sm">

// 				<DialogTitle className="head-font">{t("Enter phone number")}</DialogTitle>
// 				<DialogContent>
// 					<Formik
// 						initialValues={{ phoneNumber: "" }}
// 						validationSchema={validationSchema}
// 						onSubmit={handleSendCode}
// 					>
// 						{({ values, setFieldValue }) => (
// 							<Form>
// 								<Field name="phoneNumber">
// 									{({ field }) => (
// 										<PhoneInput
// 											className="sub-font"
// 											{...field}
// 											placeholder={t("Enter phone number")}
// 											value={values.phoneNumber}
// 											onChange={(value) => setFieldValue("phoneNumber", value)}
// 											defaultCountry="SA"
// 											style={{ width: "100%", marginBottom: "20px" }}
// 										/>
// 									)}
// 								</Field>
// 								<ErrorMessage
// 									name="phoneNumber"
// 									component="div"
// 									style={{ color: "red", marginBottom: "10px" }}
// 								/>
// 								<Button className="head-font" type="submit" variant="contained" fullWidth>
// 									{t("Send Verification Code")}
// 								</Button>
// 							</Form>
// 						)}
// 					</Formik>

// 				</DialogContent>
// 			</Dialog>
// 			<Dialog className="alignByLang" open={openVerifiyDialog} onClose={() => setOpenVerifiyDialog(false)} fullWidth maxWidth="sm">
// 				<DialogTitle className="head-font">{t("Enter Verification Code")}</DialogTitle>
// 				<DialogContent>
// 					<TextField
// 						className="sub-font"
// 						label={<span className="sub-font">{t("Verification Code")}</span>}
// 						variant="outlined"
// 						fullWidth
// 						value={verificationCode}
// 						onChange={(e) => setVerificationCode(e.target.value)}
// 						style={{ marginTop: "20px" }}
// 						sx={{
// 							".MuiInputBase-input": {
// 								fontFamily:
// 									getLocalStorageMenuItem("lang") === "ar" ||
// 										getLocalStorageMenuItem("lang") === "fa"
// 										? "Almarai"
// 										: "Roboto",
// 							}
// 						}}
// 					/>
// 				</DialogContent>
// 				<DialogActions>
// 					<Button className="head-font" onClick={() => setOpenVerifiyDialog(false)} color="secondary">
// 						{t("Cancel")}
// 					</Button>
// 					<Button className="head-font" onClick={handleVerifyCode} color="primary">
// 						{t("Verify")}
// 					</Button>
// 				</DialogActions>
// 			</Dialog>

// 			<SaveCustomerNameDialog openSaveNameDialogVal={openSaveNameDialog} customerName={customerName} setCustomerNameVal={(cust_name) => setCustomerName(cust_name)} handleSaveCustomerName={saveCustomerName} />

// 			<Toast
// 				open={toastSettings.open}
// 				message={toastSettings.message}
// 				resetToast={handleCloseToast}
// 				success={toastSettings.success}
// 			/>
// 		</div>

// 	);
// };

// export default LoginComponent;


import React, { useState, useEffect } from "react";
import {
	Backdrop,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
	Typography,
	Box,
	SwipeableDrawer,
	styled,
	useTheme
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { t } from "i18next";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Loading from "../../../common/loading";
import { getLocalStorageMenuItem, setLocalStorageMenuItem } from "../../../utility";
import SaveCustomerNameDialog from "../../SaveCustomerNameDialog";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from "../../../common/toast";

const StyledPhoneInput = styled(Box)(({ theme }) => ({
	'& .PhoneInput': {
		width: '100%',
		padding: '12px 16px',
		borderRadius: '8px',
		border: `1px solid ${theme.palette.divider}`,
		fontSize: '16px',

		transition: theme.transitions.create(['border-color', 'box-shadow']),
		'&:hover': {
			borderColor: theme.palette.primary.main,
		},
		'&:focus-within': {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
		},
	},
	'& .PhoneInputInput': {
		border: 'none',
		outline: 'none',
		width: '100%',
		fontSize: '16px',
		fontFamily: theme.typography.fontFamily,
		padding: '8px 0',
		direction: "left"
	},
	'& .PhoneInputCountry': {
		marginRight: '12px',
	},
	'& .PhoneInputCountrySelectArrow': {
		color: theme.palette.text.secondary,
	},
}));

const LoginComponent = ({
	open,
	handleCloseDialog,
	tableQr,
	tableName,
	onVerificationSuccess,
	is_from
}) => {
	const theme = useTheme();
	const [verificationCode, setVerificationCode] = useState("");
	const [loading, setLoading] = useState(false);
	const [phone, setPhone] = useState("");
	const [openVerifiyDialog, setOpenVerifiyDialog] = useState(false);
	const [customerName, setCustomerName] = useState("");
	const [openSaveNameDialog, setOpenSaveNameDialog] = useState(false);
	const [token, setToken] = useState("");
	const [resendTimer, setResendTimer] = useState(0);
	const [codeSentTime, setCodeSentTime] = useState(null);

	const [toastSettings, setToastSettings] = useState({
		open: false,
		message: "",
		success: false,
	});

	useEffect(() => {
		let timer;
		if (resendTimer > 0) {
			timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
		}
		return () => clearTimeout(timer);
	}, [resendTimer]);

	const startResendTimer = () => {
		setResendTimer(120); // 2 minutes in seconds
		setCodeSentTime(new Date());
	};

	const formatTime = (seconds) => {
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
	};

	const handleOpenToast = (message, state) => {
		setToastSettings({
			open: true,
			success: state,
			message: message
		});
	};

	const handleCloseToast = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setToastSettings({ open: false, message: "", success: false });
	};

	function useQueryParams() {
		const { search } = useLocation();
		return new URLSearchParams(search);
	}

	const navigate = useNavigate();
	const query = useQueryParams();

	const tParam = query.get("t");
	const lang = query.get("lang");

	const validationSchema = Yup.object().shape({
		phoneNumber: Yup.string()
			.required(t("Phone number is required"))
			.test(
				"isValidPhoneNumber",
				t("Enter a valid phone number"),
				(value) => isValidPhoneNumber(value || "")
			),
	});

	const handleOpenSaveNameDialog = (token) => {
		setToken(token);
		setOpenVerifiyDialog(false);
		setOpenSaveNameDialog(true);
	}

	const saveCustomerName = async () => {
		if (!customerName) {
			handleOpenToast(
				<div className="alignByLang">
					{t("Please enter your name.")}
				</div>
				, false);
			return;
		}
		setLoading(true);
		try {
			const response = await axios.post(`${process.env.REACT_APP_API}/customer/save-name`, {
				name: customerName,
			}, {
				headers: {
					Authorization: `Bearer ${token}`,
				}
			});
			if (response?.data?.success) {
				handleOpenToast(
					<div className="alignByLang">
						{t("Name updated successfully.")}
					</div>
					, true);
				onVerificationSuccess(token);
				setOpenSaveNameDialog(false);
			} else {
				handleOpenToast(
					<div className="alignByLang">
						{t("Error while saving the name.")}
					</div>
					, false);
			}
		} catch (error) {
			handleOpenToast(
				<div className="alignByLang">
					{t("Error while saving the name: ") + error.message}
				</div>
				, false);
		} finally {
			setLoading(false);
		}
	};

	const handleSendCode = async (values) => {
		setLoading(true);
		try {
			const response = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
				phone: values.phoneNumber,
				menu_code: tableQr,
			});

			if (response?.data?.success) {
				setPhone(values.phoneNumber);
				handleCloseDialog();
				setOpenVerifiyDialog(true);
				startResendTimer();
				handleOpenToast(
					<div className="alignByLang">
						{t("Verification code sent successfully.")}
					</div>
					, true);
			} else {
				handleOpenToast(
					<div className="alignByLang">
						{t("Error while sending the verification code.")}
					</div>
					, false);
			}
		} catch (error) {
			handleOpenToast(
				<div className="alignByLang">
					{t("Error while sending the verification code: ") + error.message}
				</div>
				, false);
		} finally {
			setLoading(false);
		}
	};

	const handleResendCode = async () => {
		setLoading(true);
		try {
			const response = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
				phone: phone,
				menu_code: tableQr,
			});

			if (response?.data?.success) {
				startResendTimer();
				handleOpenToast(
					<div className="alignByLang">
						{t("New verification code sent successfully.")}
					</div>
					, true);
			} else {
				handleOpenToast(
					<div className="alignByLang">
						{t("Error while resending the verification code.")}
					</div>
					, false);
			}
		} catch (error) {
			handleOpenToast(
				<div className="alignByLang">
					{t("Error while resending the verification code: ") + error.message}
				</div>
				, false);
		} finally {
			setLoading(false);
		}
	};

	const handleVerifyCode = async () => {
		if (!verificationCode) {
			handleOpenToast(
				<div className="alignByLang">
					{t("Please enter the verification code.")}
				</div>
				, false);
			return;
		}

		setLoading(true);
		try {
			const response = await axios.post(`${process.env.REACT_APP_API}/customer/check-otp`, {
				phone,
				otp: verificationCode,
			});

			if (response?.data?.success) {
				setVerificationCode("");
				if (response?.data?.data?.name) {
					setLocalStorageMenuItem("customer_name", response?.data?.data?.name || "");
					setLocalStorageMenuItem("customer_balance", response?.data?.data?.balance || 0);
					setLocalStorageMenuItem("mobileLoginToken", response?.data?.data?.token || "");
					onVerificationSuccess(response?.data?.data?.token);
					setOpenVerifiyDialog(false);

					if (is_from === 1) {
						navigate(`/${tableName}/${tableQr}/sections?section=0&t=${tParam}&lang=${lang}`);
					} else if (is_from === 2) {
						window.location.reload();
					}
				} else {
					handleOpenSaveNameDialog(response?.data?.data?.token);
				}
			} else {
				handleOpenToast(
					<div className="alignByLang">
						{t("Invalid verification code. Please try again.")}
					</div>
					, false);
			}
		} catch (error) {
			handleOpenToast(
				<div className="alignByLang">
					{t("Error while verifying the code: ") + error.message}
				</div>
				, false);
		} finally {
			setLoading(false);
		}
	};

	if (loading) {
		return <Loading />;
	}



	return (
		<div>
			<ToastContainer />
			<Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
				<CircularProgress color="inherit" />
			</Backdrop>

			{/* Phone Number Drawer */}
			<SwipeableDrawer
				anchor="bottom"
				open={open}
				onClose={handleCloseDialog}
				onOpen={() => { }}
				disableSwipeToOpen={true}
				PaperProps={{
					sx: {
						borderTopLeftRadius: '16px',
						borderTopRightRadius: '16px',
						padding: theme.spacing(3, 2, 4),
						background: theme.palette.background.paper,
						boxShadow: theme.shadows[10],
					}
				}}
			>
				<Box sx={{ textAlign: 'center', mb: 2 }}>
					<Box sx={{
						width: '40px',
						height: '4px',
						backgroundColor: theme.palette.divider,
						borderRadius: '2px',
						margin: '0 auto 16px',
					}} />
					<Typography variant="h6" sx={{
						fontWeight: 'bold',
						color: theme.palette.text.primary,
						mb: 1
					}}>
						{t("Welcome")}
					</Typography>
					<Typography variant="body2" sx={{
						color: theme.palette.text.secondary,
						mb: 3
					}}>
						{t("Enter your phone number to continue")}
					</Typography>
				</Box>

				<Formik
					initialValues={{ phoneNumber: "" }}
					validationSchema={validationSchema}
					onSubmit={handleSendCode}
				>
					{({ values, setFieldValue, errors, touched }) => (
						<Form>
							<Field name="phoneNumber">
								{({ field }) => (
									<StyledPhoneInput>
										<PhoneInput
											{...field}
											placeholder={t("Phone number")}
											value={values.phoneNumber}
											onChange={(value) => setFieldValue("phoneNumber", value)}
											defaultCountry="SA"
											international
											withCountryCallingCode
											// countrySelectProps={{ unicodeFlags: true }}
											style={{ width: '100%' }}
											className="alignByLang"

										/>
									</StyledPhoneInput>
								)}
							</Field>
							<ErrorMessage
								name="phoneNumber"
								component="div"
								style={{
									color: theme.palette.error.main,
									margin: '8px 0 16px',
									fontSize: '0.875rem',
									textAlign: 'center'
								}}
							/>

							<Button
								type="submit"
								variant="contained"
								fullWidth
								size="large"
								sx={{
									mt: 2,
									py: 1.5,
									fontWeight: 'bold',
									textTransform: 'none',
									fontSize: '1rem',
									borderRadius: '12px',
									boxShadow: 'none',
									'&:hover': {
										boxShadow: 'none',
									}
								}}
							>
								{t("Continue")}
							</Button>
						</Form>
					)}
				</Formik>
			</SwipeableDrawer>

			{/* Verification Code Dialog */}
			<Dialog
				open={openVerifiyDialog}
				onClose={() => setOpenVerifiyDialog(false)}
				fullWidth
				maxWidth="sm"
				PaperProps={{
					sx: {
						borderRadius: '16px',
						padding: theme.spacing(3),
						background: theme.palette.background.paper,
					}
				}}
			>
				<DialogTitle sx={{
					textAlign: 'center',
					fontWeight: 'bold',
					px: 0,
					pt: 0
				}}>
					{t("Enter Verification Code")}
				</DialogTitle>
				<DialogContent className="alignByLang">
					<DialogContentText sx={{
						mb: 3,
						textAlign: 'center',
						color: theme.palette.text.secondary
					}}>
						{t("We've sent a verification code to")} <span style={{ fontWeight: 'bold', color: theme.palette.text.primary }}>{phone}</span>
					</DialogContentText>

					<TextField
						placeholder={t("Verification Code")}
						variant="outlined"
						fullWidth
						value={verificationCode}
						onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
						sx={{
							mb: 2,
							"& .MuiOutlinedInput-root": {
								borderRadius: '12px',
								direction: getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa" ? 'rtl' : 'ltr',
								"& fieldset": {
									borderColor: theme.palette.divider,
								},
								"&:hover fieldset": {
									borderColor: theme.palette.primary.main,
								},
								"&.Mui-focused fieldset": {
									borderColor: theme.palette.primary.main,
									boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
								},
								"& input::placeholder": {
									textAlign: getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa" ? 'right' : 'left',
									opacity: 1,
									color: theme.palette.text.secondary,
									fontSize: '0.9rem',
									letterSpacing: 'normal',
									fontWeight: 'normal',
								},
								"& input": {
									textAlign: 'center',
									fontSize: '1.5rem',
									letterSpacing: '0.5rem',
									padding: '16px 14px',
									fontWeight: 'bold',
									color: theme.palette.text.primary,
								}
							}
						}}
						InputProps={{
							sx: {
								textAlign: 'center',
							}
						}}
						inputProps={{
							maxLength: 6,
							inputMode: 'numeric',
							pattern: '[0-9]*',
							dir: 'ltr', // Keep input numbers always LTR
							style: {
								textAlign: 'center'
							},
							placeholder: t("Verification Code"), // Additional placeholder for better compatibility
						}}
					/>

					<Box sx={{
						textAlign: 'center',
						mt: 2,
						mb: 1
					}}>
						{resendTimer > 0 ? (
							<Typography variant="body2" sx={{
								color: theme.palette.text.secondary,
								fontSize: '0.875rem'
							}}>
								{t("Request new code in")} <span style={{ fontWeight: 'bold' }}>{formatTime(resendTimer)}</span>
							</Typography>
						) : (
							<Button
								onClick={handleResendCode}
								color="primary"
								size="small"
								sx={{
									textTransform: 'none',
									fontSize: '0.875rem'
								}}
							>
								{t("Didn't receive code? Resend")}
							</Button>
						)}
					</Box>
				</DialogContent>
				<DialogActions sx={{
					justifyContent: 'space-between',
					padding: theme.spacing(0, 3, 2),
					gap: 2
				}}>
					<Button
						onClick={() => setOpenVerifiyDialog(false)}
						sx={{
							textTransform: 'none',
							color: theme.palette.text.secondary,
							borderRadius: '12px',
							px: 3,
							py: 1
						}}
					>
						{t("Back")}
					</Button>
					<Button
						onClick={handleVerifyCode}
						variant="contained"
						sx={{
							textTransform: 'none',
							fontWeight: 'bold',
							px: 3,
							py: 1,
							borderRadius: '12px',
							boxShadow: 'none',
							'&:hover': {
								boxShadow: 'none',
							}
						}}
						disabled={!verificationCode}
					>
						{t("Verify")}
					</Button>
				</DialogActions>
			</Dialog>

			<SaveCustomerNameDialog
				openSaveNameDialogVal={openSaveNameDialog}
				customerName={customerName}
				setCustomerNameVal={(cust_name) => setCustomerName(cust_name)}
				handleSaveCustomerName={saveCustomerName}
			/>

			<Toast
				open={toastSettings.open}
				message={toastSettings.message}
				resetToast={handleCloseToast}
				success={toastSettings.success}
			/>
		</div>
	);
};

export default LoginComponent;